<template>
  <div>
    <div
      v-if="data.topic === 'identificationId'"
      class="columns"
    >
      <div class="column">
        <b-field id="identification-id">
          <b-input
            v-validate="'required|isThaiIdCard'"
            v-if="(form.nationality && form.nationality === 'Thai') || (nationality === 'Thai' && !form.hasOwnProperty('nationality'))"
            v-model="form.identificationId"
            :placeholder="$t('kyc.id_card_placeholder')"
            name="identification id"
            autocomplete="disabled"
            data-test="edit-kyc-identify--identification-id-field"
          />
          <b-input
            v-validate="{required: true, max:10}"
            v-else
            v-model="form.identificationId"
            :placeholder="$t('kyc.id_card_placeholder')"
            name="identification id"
            autocomplete="disabled"
            data-test="edit-kyc-identify--identification-id-field"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('identification id') }}</span>
      </div>
    </div>
    <div
      v-if="(nationality === 'Thai' || (form.nationality && form.nationality === 'Thai')) && data.topic === 'laserCode'"
      class="columns"
    >
      <div class="column">
        <b-field id="laser-code">
          <b-input
            v-validate="'required|isLaserCode'"
            v-model="form.laserCode"
            :placeholder="$t('kyc.laser_code_placeholder')"
            name="laser code"
            autocomplete="disabled"
            data-test="edit-kyc-identify--laser-code-field"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('laser code') }}</span>
        <div
          class="example-text"
          style="text-align: left;"
          @click="isExLaserCodeModalActive = true"
        >
          {{ $t('kyc.ex_laser_code') }}
        </div>
        <b-modal :active.sync="isExLaserCodeModalActive">
          <p class="image example-img-modal">
            <img src="https://empui.doe.go.th/assets/img/id-card.png">
          </p>
        </b-modal>
      </div>
    </div>
    <div class="columns is-desktop">
      <div
        v-if="data.topic === 'issueDateOfId'"
        class="column"
      >
        <b-field
          id="date-of-issue"
          data-test="edit-kyc-identify--date-of-issue-field"
        >
          <b-datepicker
            v-validate="'required|dateBeforeNow'"
            v-model="form.issueDateOfId"
            :mobile-native="false"
            :years-range="[-200, 200]"
            :placeholder="$t('kyc.click_to_select')"
            icon="calendar-today"
            name="date of issue"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('date of issue') }}</span>
      </div>
      <div
        v-if="data.topic === 'expireDateOfId'"
        class="column"
      >
        <b-field
          id="date-of-expire"
          data-test="edit-kyc-identify--date-of-expire-field"
        >
          <b-datepicker
            v-validate="{required: !isDisableExpireDate , dateAfterNow: !isDisableExpireDate }"
            v-model="form.expireDateOfId"
            :disabled="isDisableExpireDate"
            :mobile-native="false"
            :years-range="[-200, 200]"
            :placeholder="$t('kyc.click_to_select')"
            icon="calendar-today"
            name="date of expire"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('date of expire') }}</span>
        <b-field
          v-if="(form.nationality && form.nationality === 'Thai') || (nationality === 'Thai' && !form.hasOwnProperty('nationality'))"
          data-test="edit-kyc-identify--lifetime-checkbox"
        >
          <b-checkbox
            v-model="form.isLifetime"
            :false-value="false"
            :true-value="$t('kyc.life_time_id_card')"
            name="Lifetime"
          >
            {{ $t('kyc.life_time_id_card') }}
          </b-checkbox>
        </b-field>
      </div>
    </div>
    <div
      v-if="data.topic === 'identificationPicture'"
      class="columns mg-t-20px"
    >
      <div class="column document-box">
        <div
          id="id-card-photo"
          class="strong-text"
        >
          {{ $t('kyc.upload_id_card', { typeOfCard: typeOfCard === 'Passport' ? $t('kyc.passport') : $t('kyc.id_card') }) }}
        </div>
        <div class="pale-text">
          ({{ $t('kyc.max_file_type', [limitPictureFileSizeInMb]) }})
        </div>
        <div class="example-img">
          <b-upload
            v-validate="'required'"
            v-model="inputFileIdCard"
            name="ID card photo"
            accept="image/*"
            drag-drop
            @input="onUploadIdPicChange"
          >
            <section
              class="section"
              data-test="edit-kyc-identify--id-card-upload"
            >
              <div class="content has-text-centered">
                <img
                  :src="form.identificationPicture || '/static/img/front-id-card.png'"
                  class="dropzone-img"
                >
              </div>
              <div class="browse-btn">{{ $t('kyc.browse') }}</div>
            </section>
          </b-upload>
          <span class="is-invalid">{{ errors.first('ID card photo') }}</span>
        </div>
        <div
          class="example-text"
          @click="isExIdCardModalActive = true"
        >
          {{ $t('kyc.ex_id_card', { typeOfCard: typeOfCard === 'Passport' ? $t('kyc.passport') : $t('kyc.id_card') }) }}
        </div>
        <div
          v-if="isIdImageOverSize"
          class="is-invalid t-al-center"
        >
          {{ $t('messages.img_size_must_less_than', [limitPictureFileSizeInMb]) }}
        </div>
        <b-modal :active.sync="isExIdCardModalActive">
          <p class="image example-img-modal">
            <img
              v-if="typeOfCard === 'Passport'"
              src="/static/img/ex-passport.png"
            >
            <img
              v-else
              src="/static/img/ex-front-id-card.png"
            >
          </p>
        </b-modal>
      </div>
    </div>
    <div
      v-if="data.topic === 'selfIdentificationPicture'"
      class="columns mg-t-20px"
    >
      <div class="column document-box">
        <div
          id="selfie-photo"
          class="strong-text"
        >
          {{ $t('kyc.upload_selfie') }}
        </div>
        <div class="example-img">
          <b-upload
            v-validate="'required'"
            v-model="inputFileSelfie"
            name="Selfie photo"
            accept="image/*"
            drag-drop
            @input="onUploadSelfiePicChange"
          >
            <section
              class="section"
              data-test="edit-kyc-identify--selfie-id-card-upload"
            >
              <div class="content has-text-centered">
                <img
                  :src="form.selfIdentificationPicture || '/static/img/selfie-id-card.png'"
                  class="dropzone-img"
                >
              </div>
              <div class="browse-btn">{{ $t('kyc.browse') }}</div>
            </section>
          </b-upload>
          <span class="is-invalid">{{ errors.first('Selfie photo') }}</span>
        </div>
        <div
          class="example-text"
          @click="isExSelfieModalActive = true"
        >
          {{ $t('kyc.ex_selfie') }}
        </div>
        <div
          v-if="isSelfImageOverSize"
          class="is-invalid t-al-center"
        >
          ({{ $t('kyc.max_file_type', [limitPictureFileSizeInMb]) }})
        </div>
        <b-modal :active.sync="isExSelfieModalActive">
          <p class="image example-img-modal">
            <img src="/static/img/ex-selfie-id-card.jpg">
          </p>
        </b-modal>
        <div class="column upload-selfie-detail">
          <ul>
            <li v-html="$t('kyc.detail_selfie.l1')"/>
            <li v-html="$t('kyc.detail_selfie.l2', { typeOfCard: typeOfCard === 'Passport' ? $t('kyc.passport') : $t('kyc.id_card') })"/>
            <li v-html="$t('kyc.detail_selfie.l3')"/>
            <li v-html="$t('kyc.detail_selfie.l4')"/>
            <li v-html="$t('kyc.detail_selfie.l5')"/>
          </ul>
        </div>
      </div>
    </div>

    <!-- Spacial case topic FATCA require 3 field-->
    <div v-if="data.topic === 'FATCA'">
      <p
        class="facta subtitle"
        v-html="$t('kyc.facta_sub_title')"
      />
      <div class="columns">
        <div class="column">
          <b-field
            id="is-american"
            :label="$t('kyc.is_american')"
          >
            <div data-test="edit-kyc-identify--is-american-radio">
              <b-radio
                v-validate="'required'"
                v-model="form.isAmerican"
                :native-value="true"
                name="is american"
              >
                {{ $t('kyc.say_yes') }}
              </b-radio>
              <b-radio
                v-validate="'required'"
                v-model="form.isAmerican"
                :native-value="false"
                name="is american"
              >
                {{ $t('kyc.say_no') }}
              </b-radio>
            </div>
          </b-field>
          <span class="is-invalid">{{ errors.first('is american') }}</span>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-field
            id="is-american-for-pay-tax"
            :label="$t('kyc.is_american_for_pay_tax')"
          >
            <div data-test="edit-kyc-identify--is-american-for-pay-tax-radio">
              <b-radio
                v-validate="'required'"
                v-model="form.isAmericanForPayTax"
                :native-value="true"
                name="is american for pay tax"
              >
                {{ $t('kyc.say_yes') }}
              </b-radio>
              <b-radio
                v-validate="'required'"
                v-model="form.isAmericanForPayTax"
                :native-value="false"
                name="is american for pay tax"
              >
                {{ $t('kyc.say_no') }}
              </b-radio>
            </div>
          </b-field>
          <span class="is-invalid">{{ errors.first('is american for pay tax') }}</span>
        </div>
      </div>
      <div
        v-if="isDisplayAmericanTaxId"
        class="columns"
      >
        <div class="column">
          <b-field
            id="american-tax-id"
            :label="$t('kyc.american_tax_id')"
          >
            <b-input
              v-validate="'required'"
              v-model="form.americanTaxId"
              :placeholder="$t('kyc.american_tax_id_placeholder')"
              name="american tax id"
              autocomplete="disabled"
              data-test="edit-kyc-identify--american-tax-id-field"
            />
          </b-field>
          <span class="is-invalid">{{ errors.first('american tax id') }}</span>
        </div>
      </div>
    </div>

    <div id="edit-kyc-custom-upload">
      <!-- Company certificate document -->
      <div
        v-if="data.topic === 'orgCompanyCert'"
        class="columns mg-t-20px"
      >
        <div class="column document-box">
          <div class="example-img">
            <b-upload
              v-validate="'required'"
              v-model="form.orgCompanyCert"
              name="company cert"
              accept="image/*,.pdf"
              drag-drop
              @input="(file) => onUploadDoc(file, 'orgCompanyCert')"
            >
              <section
                class="section"
                data-test="edit-kyc-upload-org-doc--company-cert"
              >
                <div class="content has-text-centered">
                  <img
                    src="/static/img/icon-company-cer-doc.png"
                    class="dropzone-img--certificate"
                  >
                </div>
                <div class="browse-btn">{{ $t('kyc.browse_file') }}</div>
              </section>
            </b-upload>
            <span class="is-invalid">{{ errors.first('company cert') }}</span>
            <b-tag
              v-if="form.orgCompanyCert"
              type="is-primary"
            >
              {{ form.orgCompanyCert.name }}
            </b-tag>
            <div
              v-if="orgCompanyCertOverSize"
              class="is-invalid t-al-center"
            >
              {{ $t('kyc.doc_limit') }} {{ limitDocFileSizeInMb }} MB
            </div>
          </div>
        </div>
      </div>
      <!-- List of shareholders document -->
      <div
        v-if="data.topic === 'orgShareholders'"
        class="columns mg-t-20px"
      >
        <div class="column document-box">
          <div class="example-img">
            <b-upload
              v-validate="'required'"
              v-model="form.orgShareholders"
              name="shareholders"
              accept="image/*,.pdf"
              drag-drop
              @input="(file) => onUploadDoc(file, 'orgShareholders')"
            >
              <section
                class="section"
                data-test="edit-kyc-upload-org-doc--shareholders"
              >
                <div class="content has-text-centered">
                  <img
                    src="/static/img/icon-list-shareholder.png"
                    class="dropzone-img--shareholders"
                  >
                </div>
                <div class="browse-btn">{{ $t('kyc.browse_file') }}</div>
              </section>
            </b-upload>
            <span class="is-invalid">{{ errors.first('shareholders') }}</span>
            <b-tag
              v-if="form.orgShareholders"
              type="is-primary"
            >
              {{ form.orgShareholders.name }}
            </b-tag>
            <div
              v-if="orgShareholdersOverSize"
              class="is-invalid t-al-center"
            >
              {{ $t('kyc.doc_limit') }} {{ limitDocFileSizeInMb }} MB
            </div>
          </div>
        </div>
      </div>
      <!-- Seal certificate document -->
      <div
        v-if="data.topic === 'orgSealCert'"
        class="columns mg-t-20px"
      >
        <div class="column document-box">
          <div class="example-img">
            <b-upload
              v-validate="'required'"
              v-model="form.orgSealCert"
              name="seal cert"
              accept="image/*,.pdf"
              drag-drop
              @input="(file) => onUploadDoc(file, 'orgSealCert')"
            >
              <section
                class="section"
                data-test="edit-kyc-upload-org-doc--seal-cert"
              >
                <div class="content has-text-centered">
                  <img
                    src="/static/img/icon-list-shareholder.png"
                    class="dropzone-img--shareholders"
                  >
                </div>
                <div class="browse-btn">{{ $t('kyc.browse_file') }}</div>
              </section>
            </b-upload>
            <span class="is-invalid">{{ errors.first('seal cert') }}</span>
            <b-tag
              v-if="form.orgSealCert"
              type="is-primary"
            >
              {{ form.orgSealCert.name }}
            </b-tag>
            <div
              v-if="orgSealCertOverSize"
              class="is-invalid t-al-center"
            >
              {{ $t('kyc.doc_limit') }} {{ limitDocFileSizeInMb }} MB
            </div>
          </div>
        </div>
      </div>
      <!-- Copy of house registration  of authorized director -->
      <div
        v-if="data.topic === 'orgHouseRegisAuthDirector'"
        class="columns mg-t-20px"
      >
        <div class="column document-box">
          <div class="example-img">
            <b-upload
              v-validate="'required'"
              v-model="form.orgHouseRegisAuthDirector"
              name="house regis auth director"
              accept="image/*,.pdf"
              drag-drop
              @input="(file) => onUploadDoc(file, 'orgHouseRegisAuthDirector')"
            >
              <section
                class="section"
                data-test="edit-kyc-upload-org-doc--house-regis-auth-director"
              >
                <div class="content has-text-centered">
                  <img
                    src="/static/img/icon-company-cer-doc.png"
                    class="dropzone-img--certificate"
                  >
                </div>
                <div class="browse-btn">{{ $t('kyc.browse_file') }}</div>
              </section>
            </b-upload>
            <span class="is-invalid">{{ errors.first('house regis auth director') }}</span>
            <b-tag
              v-if="form.orgHouseRegisAuthDirector"
              type="is-primary"
            >
              {{ form.orgHouseRegisAuthDirector.name }}
            </b-tag>
            <div
              v-if="orgHouseRegisAuthDirectorOverSize"
              class="is-invalid t-al-center"
            >
              {{ $t('kyc.doc_limit') }} {{ limitDocFileSizeInMb }} MB
            </div>
          </div>
        </div>
      </div>
      <!-- Power of attorney (optional) and message to use the service -->
      <div
        v-if="data.topic === 'orgPowerAttorney'"
        class="columns mg-t-20px"
      >
        <div class="column document-box">
          <div class="example-img">
            <b-upload
              v-model="form.orgPowerAttorney"
              name="power attorney"
              accept="image/*,.pdf"
              drag-drop
              @input="(file) => onUploadDoc(file, 'orgPowerAttorney')"
            >
              <section
                class="section"
                data-test="edit-kyc-upload-org-doc--power-attorney"
              >
                <div class="content has-text-centered">
                  <img
                    src="/static/img/icon-power-of-attorney.png"
                    class="dropzone-img--attorney"
                  >
                </div>
                <div class="browse-btn">{{ $t('kyc.browse_file') }}</div>
              </section>
            </b-upload>
            <span class="is-invalid">{{ errors.first('power attorney') }}</span>
            <b-tag
              v-if="form.orgPowerAttorney"
              type="is-primary"
            >
              {{ form.orgPowerAttorney.name }}
            </b-tag>
            <div
              v-if="orgPowerAttorneyOverSize"
              class="is-invalid t-al-center"
            >
              {{ $t('kyc.doc_limit') }} {{ limitDocFileSizeInMb }} MB
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getBase64, resizeImage } from '@/utils/helper'
import { KYC_PICTURE_FILE_SIZE_LIMIT_IN_MB, KYC_DOC_FILE_SIZE_LIMIT_IN_MB } from '@/constants'

export default {
  name: 'Identify',
  inject: ['$validator'],
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    data: {
      type: Object,
      default: () => {}
    },
    nationality: {
      type: String,
      required: true
    },
    typeOfCard: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isExLaserCodeModalActive: false,
      isExIdCardModalActive: false,
      isExSelfieModalActive: false,
      isIdImageOverSize: false,
      isSelfImageOverSize: false,
      orgCompanyCertOverSize: false,
      orgShareholdersOverSize: false,
      orgSealCertOverSize: false,
      orgHouseRegisAuthDirectorOverSize: false,
      orgPowerAttorneyOverSize: false,
      limitPictureFileSizeInMb: KYC_PICTURE_FILE_SIZE_LIMIT_IN_MB,
      limitDocFileSizeInMb: KYC_DOC_FILE_SIZE_LIMIT_IN_MB,
      inputFileIdCard: null,
      inputFileSelfie: null
    }
  },
  computed: {
    isDisableExpireDate () {
      return Boolean(this.form.isLifetime)
    },
    isDisplayAmericanTaxId () {
      if (this.form.isAmerican || this.form.isAmericanForPayTax) {
        return true
      }
      return false
    }
  },
  watch: {
    isDisplayAmericanTaxId (newVal, oldVal) {
      if (newVal !== oldVal) {
        delete this.form.americanTaxId
      }
    }
  },
  methods: {
    openTermsPage () {
      const routeData = this.$router.resolve({ name: 'Terms' })
      window.open(routeData.href, '_blank')
    },
    async onUploadIdPicChange (file) {
      if ((file.size / 1000000) > KYC_PICTURE_FILE_SIZE_LIMIT_IN_MB) {
        this.isIdImageOverSize = true
        this.form.identificationPicture = null
        return
      }
      this.isIdImageOverSize = false
      const base64 = await getBase64(file)
      const image = await resizeImage(base64)
      this.form.identificationPicture = image
      this.$forceUpdate() // Force re-render
    },
    async onUploadSelfiePicChange (file) {
      if ((file.size / 1000000) > KYC_PICTURE_FILE_SIZE_LIMIT_IN_MB) {
        this.isSelfImageOverSize = true
        this.form.selfIdentificationPicture = null
        return
      }
      this.isSelfImageOverSize = false
      const base64 = await getBase64(file)
      const image = await resizeImage(base64)
      this.form.selfIdentificationPicture = image
      this.$forceUpdate() // Force re-render
    },
    async onUploadDoc (file, key) {
      this[`${key}OverSize`] = false
      if ((file.size / 1000000) > this.limitDocFileSizeInMb) {
        this[`${key}OverSize`] = true
        this.form[key] = null
      }
    }
  }
}
</script>

<style lang="scss">
.kyc-id-passport-is-expanded {
  .control {
    .select {
      width: 100%;
      select {
        width: 100%;
      }
    }
  }
}
#edit-kyc-custom-upload {
  .upload .upload-draggable {
    width: 470px;
  }
  .tag {
    margin-top: 10px;
    span {
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

@media only screen and (max-width: 768px) {
  #edit-kyc-custom-upload {
    .upload .upload-draggable {
      width: 100%;
    }
    .tag {
      width: 100%;
    }
  }
}
</style>

<style lang="scss" scoped>
.document-box {
  width: 100%;
  max-width: 70%;
  margin: 0 auto;
}
.strong-text {
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 0.3px;
  color: #000000;
  margin-top: 30px;
}
.pale-text {
  font-size: 15px;
  font-weight: 500;
  line-height: 1.67;
  letter-spacing: 0.37px;
  color: #939393;
  margin-top: 5px;
  &.center {
    text-align: center;
  }
}
.example-img {
  text-align: center;
  margin-top: 20px;
}
.example-img-modal {
  width: 80%;
  margin: auto;
}
.dropzone-img {
  max-width: 350px;
  width: 100%;
  &--certificate {
    max-width: 173px;
    width: 100%;
  }
  &--shareholders {
    max-width: 420px;
    width: 100%;
  }
  &--attorney {
    max-width: 236px;
    width: 100%;
  }
}
.browse-btn {
  border-radius: 3px;
  background-color: #069bf9;
  max-width: 250px;
  padding: 13px;
  color: #fff;
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 0.37px;
  margin: 0 auto;
  text-align: center;
  cursor: pointer;
  margin-top: 20px;
}
.example-text {
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0.37px;
  color: #0559af;
  text-decoration: underline;
  margin: 0 auto;
  text-align: center;
  cursor: pointer;
  margin-top: 20px;
  font-weight: bold;
}
.mg-t-20px {
  margin-top: 20px;
}
.t-al-center {
  text-align: center;
}
.upload-selfie-detail {
  margin-top: 15px;
  line-height: 2;
  ul {
    list-style-type: disc;
  }
}
/* Mobile */
@media only screen and (max-width: 768px) {
  .document-box {
    max-width: 95%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/SummaryOfKYC/components/Identify.vue